"use strict";
/**
 * @license
 * Copyright Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @fileoverview This file exports a default instance of the CSS sanitizer,
 * similarly to how the default instance of the HTML sanitizer is exported.
 *
 * The reason why it's in a separate file is to ensure that html_sanitizer.ts
 * doesn't depend on html_sanitizer_builder.ts, which would cause
 * a circular dependency.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeHtmlWithCss = void 0;
const pure_js_1 = require("../../internals/pure.js");
const html_sanitizer_builder_js_1 = require("./html_sanitizer_builder.js");
const defaultCssSanitizer = /* #__PURE__ */ (0, pure_js_1.pure)(() => new html_sanitizer_builder_js_1.CssSanitizerBuilder().build());
/** Sanitizes untrusted CSS using the default sanitizer configuration. */
function sanitizeHtmlWithCss(css) {
    return defaultCssSanitizer.sanitizeToFragment(css);
}
exports.sanitizeHtmlWithCss = sanitizeHtmlWithCss;
